import React from "react";
import {Box, Chip, Divider, IconButton, Tooltip, Typography} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import "./style.scss";
import {Trans} from "@lingui/macro";

interface ZPlayChipListProps {
    chipsList: any[],
    selectedChipsIds: string[],
    color: string | undefined,
    updateListCallback: (list: any[]) => void,
    createChipCallback?: () => void,
    title: string,
    titleId: string,
    text: string,
    textId: string,
    showCreate?: boolean,
}

export interface ZPlayChipListState {
    chipsList: any[],
    selectedChips: any[],
}

export class ZPlayChipList extends React.Component<ZPlayChipListProps, ZPlayChipListState>{

    static defaultProps = {
        showCreate: true,
    };

    constructor(props: any) {
        super(props);

        this.state = {
            chipsList: this.props.chipsList.filter(chip=> !this.props.selectedChipsIds.includes(chip.id)),
            selectedChips: this.props.chipsList.filter(chip=> this.props.selectedChipsIds.includes(chip.id)),
        };
    }

    private selectChip = (id: string): void => {

        // Insert chip in selectedChip
        const chip = this.state.chipsList.find((item) => item.id === id);
        let selectedChips = this.state.selectedChips.concat([chip!]);

        this.setState(() => ({selectedChips: selectedChips}));
        this.props.updateListCallback(selectedChips.map((obj:any) => {
            return obj.id
        }));

        // Delete tag from allTagList
        this.setState(() => ({chipsList: this.state.chipsList.filter((item) => item.id !== id)}));
    };

    private removeChip = (id: string): void => {

        // Remove chip from selectedChip
        const selectedChips = this.state.selectedChips.filter((item) => item.id !== id);

        this.setState(() => ({selectedChips: selectedChips}));

        this.props.updateListCallback(selectedChips.map((obj:any) => {
            return obj.id
        }));

        // Insert tag in allTagList
        const deleteChip  = this.state.selectedChips.find((item) => item.id === id);
        this.setState(() => ({chipsList: this.state.chipsList.concat([deleteChip!])}));
    };


    render(){
        return(<Box mt={6}>
            <Typography mb={1} color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}>
                <Trans id={this.props.titleId}>{this.props.title}</Trans>
            </Typography>
            <Typography
                variant={"body2"}
                mb={2}
                color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}>
                <Trans id={this.props.textId}> {this.props.text}</Trans>
            </Typography>
            <Box className="chip-container" minHeight={"50px"}>
                {this.state.selectedChips.map((chip, i) =>
                    <Chip
                        key={i}
                        label={chip.value}
                        onDelete={() => this.removeChip(chip.id)}
                        sx={{
                            color: process.env.REACT_APP_DEFAULT_TEXT_COLOR,
                            background: this.props.color
                        }}/>
                )}
            </Box>
            <Divider color="white"/>
            <Box className="chip-container">
                {this.state.chipsList.map((chip, i) =>
                    <Chip
                        key={i}
                        label={chip.value}
                        onDelete={() => this.selectChip(chip.id)}
                        deleteIcon={<AddCircleIcon />}
                        sx={{
                            color: process.env.REACT_APP_DEFAULT_TEXT_COLOR,
                            background: this.props.color
                        }}/>
                )}
                {this.props.showCreate && <Tooltip title="">
                    <IconButton onClick={this.props.createChipCallback}>
                        <AddCircleIcon fontSize="small" sx={{color: process.env.REACT_APP_DEFAULT_TEXT_COLOR}}/>
                    </IconButton>
                </Tooltip>}
            </Box>
        </Box>)
    }

}